/**
 * ProductGroupsProvider
 * Contain most logic handing with Omnitech Api
 */

import React from 'react'
import LoyaltyPointTransactionsContext from './loyalty-point-transactions-context'
import { fetchLoyaltyPointTransactions } from './loyalty-point-transactions-api'

export default function LoyaltyPointTransactionsProvider({ children }) {
  const state = {
    fetchLoyaltyPointTransactions,
  }
  return (
    <LoyaltyPointTransactionsContext.Provider value={state}>
      {children}
    </LoyaltyPointTransactionsContext.Provider>
  )
}
